module.exports = __webpack_public_path__ + "static/media/question.a73b305c.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/images/SSP/question.png
// module id = 66
// module chunks = 0